import { useEffect, useSyncExternalStore } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDevAuth } from "@/context/DevAuthContext";
import { Info, MessageSquare } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

// Field trades: the 10 included employees, phrased positively (not in video ads).
export const AntiCheatNote = ({ testId = "anti-cheat-note" }) => {
  const { t } = useI18n();
  return (
    <p className="flex min-w-0 items-start gap-2 break-words rounded-lg border border-sky-500/30 bg-sky-950/30 p-2.5 text-xs text-sky-100" data-testid={testId}>
      <Info className="mt-0.5 h-4 w-4 shrink-0" /> <span className="min-w-0">{t("anticheat.text")}</span>
    </p>
  );
};

// « Ask for a custom plan / price by message »: official area, hosting page, mini-site pages, client space.
const TARGET = "/espace-developpeur/messages?nouveau=custom";
// The footer button hides while an in-page button is shown (one button per page).
let inPage = 0;
const subs = new Set();
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };
const bump = (d) => { inPage += d; subs.forEach((f) => f()); };

export const CustomPlanCta = ({ testId = "custom-plan-cta", compact = false, mini = false, footer = false, slim = false, textKey }) => {
  const { t } = useI18n();
  const { dev } = useDevAuth();
  const { pathname } = useLocation();
  const others = useSyncExternalStore(subscribe, () => inPage);
  useEffect(() => {
    if (footer) return undefined;
    bump(1);
    return () => bump(-1);
  }, [footer]);
  if (footer && others > 0) return null;
  if (footer && /^\/(espace-developpeur|espace-client|admin)(\/|$)/.test(pathname)) return null;  // these spaces show their own
  // Logged out: sign in (mini-site client sign-in on mini-site pages), then straight to the plan-request message.
  const to = dev ? TARGET : `/espace-developpeur/connexion${mini ? "?type=minisite" : ""}`;
  const remember = () => !dev && sessionStorage.setItem("fmo_after_login", TARGET);
  return (
    <div className={`flex w-full min-w-0 max-w-full flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center ${compact ? "" : `rounded-2xl border border-[rgba(245,197,66,0.3)] bg-black/30 ${slim ? "px-4 py-3" : "p-4"}`}`} data-testid={testId}>
      <p className="w-full min-w-0 text-start text-sm text-neutral-200 hyphens-none [overflow-wrap:break-word] [word-break:normal] sm:w-auto sm:flex-1 sm:basis-64">{t(textKey || (slim ? "cta.customShort" : "cta.customText"))}</p>
      <Link to={to} onClick={remember} className="btn-gold btn-sm min-h-[44px] w-full max-w-full justify-center hyphens-none whitespace-normal text-center sm:w-auto sm:shrink-0" data-testid={`${testId}-btn`}>
        <MessageSquare className="h-4 w-4 shrink-0" /> {t("cta.customBtn")}
      </Link>
    </div>
  );
};
